import { observer } from "mobx-react-lite";
import { Backdrop } from "@mui/material";
import { RotatingLines } from "react-loader-spinner";
import { useStore } from "../../../api/main/appStore";
import { tokens } from "../../../theme";

export default observer(function LoadingSpinner() {
  const { commonStore } = useStore();
  const colors = tokens();

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={commonStore.loading}
      >
        <RotatingLines
          strokeColor={`${colors.blue[200]}`}
          strokeWidth="5"
          animationDuration="1"
          width="90"
          visible={true}
        />
      </Backdrop>
    </div>
  );
});
